/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import Startpage from "./pages/Startpage.jsx";
import PageLayout from "./components/PageLayout.jsx";
import UIGenerator from "./components/PageLayout/UIGenerator.jsx";
import ContainerPage from "./pages/ContainerPage.jsx";
import * as PropTypes from "prop-types";
import TenantSettings from "./pages/TenantSettings.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import PagePage from "./pages/PagePage.jsx";
import {Route, Switch} from "wouter";
import DeploymentPage from "./pages/DeploymentPage.jsx";
import ServicePage from "./pages/ServicePage.jsx";
import NodePage from "./pages/NodePage.jsx";
import useAuth from "authClient/useAuth";
import LoginRedirect from "authClient/LoginRedirect";
import {ErrorBoundary, GlobalErrorBoundary} from "errorboundarys";
import BuildLogPage from "./pages/BuildLogPage.jsx";
import {NotificationToaster} from "./components/Notifications/NotificationToast.jsx";
import CLIAuthPage from "./pages/CLIAuthPage.jsx";
import BuildServerPage from "./pages/BuildServerPage.jsx";
import CatalogPage from "./pages/CatalogPage.jsx";
import {useEffect} from "react";
import {Socket} from "./Socket.js";


function App() {
    const {isAuthenticated, isLoading, login, checkAuth} = useAuth();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <LoginRedirect/>
    }
    return <GlobalErrorBoundary><AppContent/> </GlobalErrorBoundary>
}


export function AppContent() {
    useEffect(() => {
        Socket.connect()
    }, []);

    return (
        <>
            <PageLayout>
                <Switch>
                    <Switch>

                        <Route path={`/c/:containerId`}>
                            {params => <ErrorBoundary>
                                <ContainerPage containerId={params.containerId}/>
                            </ErrorBoundary>}
                        </Route>
                        <Route path={`/s/:serviceId`}>
                            {params => <ErrorBoundary>
                                <ServicePage serviceId={params.serviceId}/>
                            </ErrorBoundary>}
                        </Route>
                        <Route path={`/p/:pageId`}>
                            {params => <ErrorBoundary>
                                <PagePage pageId={params.pageId}/>
                            </ErrorBoundary>}
                        </Route>
                        <Route path={`/d/:deploymentId`}>
                            {params => <ErrorBoundary>
                                <DeploymentPage deploymentId={params.deploymentId}/>
                            </ErrorBoundary>}
                        </Route>
                        <Route path={`/b/:id`}>
                            {params => <ErrorBoundary>
                                <BuildLogPage buildId={params.id}/>
                            </ErrorBoundary>}
                        </Route>
                        <Route path={`/n/:nodeId`}>
                            {params => <ErrorBoundary>
                                <NodePage nodeId={params.nodeId}/>
                            </ErrorBoundary>}
                        </Route>
                        <Route path={`/bs/:buildServerId`}>
                            {params => <ErrorBoundary>
                                <BuildServerPage buildServerId={params.buildServerId}/>
                            </ErrorBoundary>}
                        </Route>
                        <Route path={`/ci/:catalogId`}>
                            {params => <ErrorBoundary>
                                <CatalogPage catalogId={params.catalogId}/>
                            </ErrorBoundary>}
                        </Route>
                        {/*Startpage*/}
                        <Route path={`/settings`}>
                            <ErrorBoundary>
                                <TenantSettings/>
                            </ErrorBoundary>
                        </Route>
                        {/*Startpage*/}
                        <Route path={`/dashboard`}>
                            <ErrorBoundary>
                                <Dashboard/>
                            </ErrorBoundary>
                        </Route>
                        {/*Startpage*/}
                        <Route path={`/cli/auth`}>
                            <ErrorBoundary>
                                <CLIAuthPage/>
                            </ErrorBoundary>
                        </Route>

                        {/*Startpage*/}
                        <Route path={`/*`}>
                            <ErrorBoundary>

                                <Dashboard/>
                                <Startpage/>
                            </ErrorBoundary>
                        </Route>


                    </Switch>

                </Switch>

            </PageLayout>
            <UIGenerator/>
            <NotificationToaster/>

        </>
    );
}

App.propTypes = {
    signOut: PropTypes.any,
    user: PropTypes.any
}


export default App;